import React from 'react';
import {
  Tag
} from '@phosphor-icons/react';

function formatBooleanLabel(value) {
  if (value === true) {
    return 'Si';
  }

  if (value === false) {
    return 'No';
  }

  return 'Sin registrar';
}

const formatDateTime = (value) => {
  if (!value) {
    return 'Sin registrar';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return 'Sin registrar';
  }

  return date.toLocaleString('es-AR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
};

function DetailItem({label, value, valueClassName = '' }) {
  const hasValue = value !== null && value !== undefined && value !== '';

  return (
    <div className="flex items-start gap-3 rounded-2xl bg-bg/35 p-4">
      <div>
        <p className="mb-1 text-sm text-content-muted">{label}</p>
        <p className={`text-base font-medium text-content ${valueClassName}`}>{hasValue ? value : 'Sin registrar'}</p>
      </div>
    </div>
  );
}

function TaskDetailsCard({ task, taskTypeLabel, priorityLabel, teamName, onViewTask }) {
  const reactivationHistory = Array.isArray(task?.reactivationHistory) ? task.reactivationHistory : [];
  const sortedReactivationHistory = [...reactivationHistory].sort((a, b) => {
    const firstDate = new Date(a?.date || 0).getTime();
    const secondDate = new Date(b?.date || 0).getTime();
    return secondDate - firstDate;
  });
  const reactivationCountFromTask = Number(task?.reactivationCount);
  const reactivationCount = Number.isFinite(reactivationCountFromTask)
    ? Math.max(reactivationCountFromTask, reactivationHistory.length)
    : reactivationHistory.length;
  const wasReactivated = reactivationCount > 0 || sortedReactivationHistory.length > 0;

  return (
    <section className="rounded-3xl border border-line bg-surface/80 p-6 shadow-lg shadow-black/10">
      <div className="mb-5 flex items-center gap-3">
        <div className="rounded-xl bg-surface-2 p-2 text-content-muted">
          <Tag size={20} />
        </div>
        <h2 className="text-xl font-semibold text-content">Detalles de la tarea</h2>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <DetailItem label="Título" value={task.title} />
        <DetailItem label="Tipo de tarea" value={taskTypeLabel} />
        <DetailItem label="Prioridad" value={priorityLabel} valueClassName="text-yellow-300" />
        <DetailItem label="Fecha programada" value={formatDateTime(task.scheduledDate)} />
        <DetailItem label="Fecha de creación" value={formatDateTime(task.createdAt)} />
        <DetailItem label="Equipo" value={teamName} />
      </div>

      <div className="mt-5 border-t border-line pt-5">
        <div className="grid gap-4 md:grid-cols-2">
          <DetailItem label="Requiere re-agendar" value={formatBooleanLabel(task?.requiresReschedule)} />
          <DetailItem label="Fue reactivada" value={formatBooleanLabel(wasReactivated)} />
          <DetailItem label="Cantidad de reactivaciones" value={reactivationCount} />
          <DetailItem label="Razon de cancelacion" value={task?.cancelReason?.trim() || 'Sin razon registrada'} valueClassName="whitespace-pre-wrap" />

          <div className="md:col-span-2">
            <DetailItem
              label="Observacion"
              value={task?.cancelObservation?.trim() || 'Sin observacion registrada'}
              valueClassName="whitespace-pre-wrap"
            />
          </div>

          {wasReactivated && (
            <div className="md:col-span-2 rounded-2xl bg-bg/35 p-4">
              <p className="mb-3 text-sm text-content-muted">Historial de reactivaciones</p>
              <div className="space-y-3">
                {sortedReactivationHistory.map((entry, index) => (
                  <div key={`${entry?.date || 'sin-fecha'}-${index}`} className="rounded-xl border border-line/80 bg-bg/40 p-3">
                    <p className="text-xs text-content-muted">Reactivacion {sortedReactivationHistory.length - index}</p>
                    <p className="mt-1 text-sm text-content">Fecha: <span className="font-medium text-content">{formatDateTime(entry?.date)}</span></p>
                    <p className="text-sm text-content">Motivo: <span className="font-medium whitespace-pre-wrap text-content">{entry?.reason?.trim() || 'Sin motivo registrado'}</span></p>
                    <p className="text-sm text-content">Reactivada por: <span className="font-medium text-content">{entry?.reactivatedByUser || entry?.reactivatedBy || 'Sin registrar'}</span></p>
                    {entry?.newScheduledDate && (
                      <p className="text-sm text-content">Nueva fecha programada: <span className="font-medium text-content">{formatDateTime(entry.newScheduledDate)}</span></p>
                    )}
                    {entry?.newTaskId && typeof onViewTask === 'function' && (
                      <div className="mt-3">
                        <button
                          type="button"
                          onClick={() => onViewTask(entry.newTaskId)}
                          className="rounded-lg bg-amber px-3 py-1.5 text-sm font-medium text-on-amber transition-colors hover:bg-amber-hover"
                        >
                          Ver Nueva Tarea
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default TaskDetailsCard;
